// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3-lGN","colBig":"styles_colBig__1E_Th","colSmall":"styles_colSmall__2k5Bc","shopifyNameWrapper":"styles_shopifyNameWrapper__38Vx7"};